import { useTheme } from "@/contexts/ThemeContext";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle({ className = "", variant = "default" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const base = "inline-flex items-center justify-center rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-400";
  const styles =
    variant === "sidebar"
      ? "w-9 h-9 bg-slate-100 hover:bg-slate-200 text-slate-600 border border-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200 dark:border-slate-700"
      : variant === "light"
      ? "w-9 h-9 bg-white hover:bg-slate-100 text-slate-600 border border-slate-200"
      : "w-9 h-9 bg-slate-100 hover:bg-slate-200 text-slate-600 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200 dark:border dark:border-slate-700";

  return (
    <button
      onClick={toggleTheme}
      className={`${base} ${styles} ${className}`}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="theme-toggle-btn"
      aria-label="Toggle theme"
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
